import { makeUnorderedSelectors } from '@/store/repository';
import { AssetList } from '@/store/types';

const selector = makeUnorderedSelectors<AssetList>();

export const { get, getAll, getOrNull } = selector;
